import React from 'react';
import BackgroundPattern from './BackgroundPattern';

const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4 relative">
      <BackgroundPattern />
      <div className="relative flex flex-col items-center z-10">
        {/* Logo/Brand Animation */}
        <div className="mb-8 relative">
          <div className="w-16 h-16 relative">
             <div className="absolute inset-0 rounded-full border-4 border-primary-100"></div>
             <div className="absolute inset-0 rounded-full border-4 border-primary-600 border-t-transparent animate-spin"></div>
          </div>
          <div className="absolute -inset-4 bg-primary-600 opacity-20 blur-xl rounded-full animate-pulse"></div>
        </div>

        {/* Loading Text */}
        <div className="flex flex-col items-center gap-2">
            <h2 className="text-xl font-bold font-proyas tracking-wider text-gray-800">PROYAS</h2>
            <div className="flex gap-1">
                <div className="w-2 h-2 bg-primary-600 rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
                <div className="w-2 h-2 bg-primary-600 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                <div className="w-2 h-2 bg-primary-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
